<div class="content-landing">
    <!-- Element 1: Introduction -->
    <div class="row elem elA">
        <div class="col-6 ">
            <img [src]="img2" class="elem-image">
        </div>
        <div class="col-6 elem-info ms-3">
            <div class="elem-head">
                <h2 class="">What is Stellantis Fleet Service Portal ?</h2>
            </div>
            <div class="elem-content">
                <p>Comprehensive overview of your Stellantis vehicles along with access to the full suite of connected service
                    subscriptions, innovative digital products, and solutions designed to enhance your fleet asset management.​
                </p>
                <div class="cta-container" *ngIf="!isSession"> 
                    <space-btn class="btn_login" aria_label='btn_login' id_btn='btn_login' disabled='false' variant='btn1' label='Login' [routerLink]="['/login']"> <!--this.configService.generateLink()-->
                        Login
                    </space-btn>
                </div>
            </div>
        </div>
    </div>
    <!-- Element 1: Features -->
    <div class="row elem elB">
        <div class="col-6 elem-info ms-3">
            <div class="elem-head">
                <h2 class="">Features</h2>
            </div>
            <div class="elem-content">
                <p class="header">Lorem ipsum dolor sit amet consectetur. Elementum nisl duis tortor sed. Suspendisse lobortis vitae quis vehicula pellentesque sit id.</p>
                <ul class="feature-checklist">
                    <li class="feature-item">
                        <img src="img/green-check.svg" class="check-icon me-2" />
                        <span>Multi-vehicle overview and insights of your fleet.</span>
                    </li>
                    <li class="feature-item">
                        <img src="img/green-check.svg" class="check-icon me-2" />
                        <span>Subscribe to and manage your Connected Services & Digital Products.</span>
                    </li>
                    <li class="feature-item">
                        <img src="img/green-check.svg" class="check-icon me-2" />
                        <span>Explore innovative fleet solutions brought to you by Stellantis and our trusted partners.</span>
                    </li>
                    <li class="feature-item">
                        <img src="img/green-check.svg" class="check-icon me-2" />
                        <span>Check your vehicles' Telematics Data capability.</span></li>
                    <li class="feature-item">
                        <img src="img/green-check.svg" class="check-icon me-2" />
                        <span>Learn about technology such as Over The Air updates, Fleet management, Telematics Data, EV Business solutions.</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-6 ">
            <img [src]="img1" class="elem-image">
        </div>
    </div>
    <!-- Element 1: Benefits -->
    <div class="row elem elB">
        <div class="col-12 elem-info">
            <div class="elem-head">
                <h2 class="">Benefits of Fleet Service Portal​</h2>
            </div>
            <div class="elem-content">
                <p>Lorem ipsum dolor sit amet consectetur. Elementum nisl duis tortor sed. Suspendisse lobortis vitae quis vehicula
                    pellentesque sit id. Urna posuere consequat velit vulputate faucibus pretium arcu accumsan sit. Vel venenatis
                    sapien.</p>
                <div class="row fleet-benefits">
                    <div class="col-md-4 benefit">
                        <div class="row">
                            <div class="col-1 benefit-img">
                                <space-icon icon='remotecontrol' outline='true'></space-icon>
                            </div>
                            <div class="col-11 benefit-content">
                                <p class="head-txt">Centralized Information</p>
                                <p class="c-txt">Access all essential health details of your connected vehicles, discover new
                                    services, trusted partnerships, and enhance vehicle management with digital products and
                                    software solutions.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 benefit">
                        <div class="row">
                            <div class="col-1 benefit-img">
                                <space-icon icon='mobile' outline='true'></space-icon>
                            </div>
                            <div class="col-11 benefit-content">
                                <p class="head-txt">Convenience</p>
                                <p class="c-txt">Manage all your Stellantis vehicles and their connected services from a
                                    single, user-friendly platform.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 benefit">
                        <div class="row">
                            <div class="col-1 benefit-img">
                                <space-icon icon='list' outline='true'></space-icon>
                            </div>
                            <div class="col-11 benefit-content">
                                <p class="head-txt">Simplified Management</p>
                                <p class="c-txt">Easily monitor vehicle health and performance at a glance, promptly address
                                    any issues, and reduce your administrative burden with integrated solutions.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
